<template>
    <div class="modal" id="modal">
        <transition name="generic-modal-transition">
            <div class="generic-modal-container"
                :class="[{
                    'modal-large': config.modalLarge,
                    'centered-on-mobile': config.centerOnMobile,
                    'modal-full-width': config.modalFullWidth,
                    'talisman-certificate': config.certificateEdit,
                    'easter-modal': config.easterModal,
                    'generic-modal-container-small': config.modalSmall,
                    'qr-modal' : config.qrModal
                },
                config.customClass]"
                v-show="isModalVisible">
                <div class="content-wrapper">
                    <button v-if="!config.hideCloseButton" class="close-modal icon-close modal-close-icon"
                        @click="() => handleCloseModal(config)">
                    <span class="sr-only">{{ modalResources.closeModal }}</span>
                    </button>

                    <component v-if="content" :is="content" v-bind="properties" />
                    <div v-else>
                        <div class="image-holder" v-if="config.productImage && config.productImage.src">
                            <img :data-src="config.productImage.src" :alt="config.productImage.alt" :src="config.productImage.placeholder" :class="config.productImage.class" />
                        </div>

                        <span :class="config.icon" v-if="config.icon"></span>

                        <div class="text-holder">
                            <h2 class="heading-h4"
                                :class="{
                                    'heading-large': config.resources && config.resources.headingLarge,
                                    'heading-small': config.resources && config.resources.headingSmall,
                                    'heading-large-narrow': config.resources && config.resources.headingNarrow
                                }"
                                v-if="config.resources && config.resources.heading"
                                v-html="config.resources.heading"
                            ></h2>

                            <template v-for="paragraph in config.paragraphs" >
                                <p :class="{
                                    'text-large': paragraph.textLarge,
                                    'text-color-black': paragraph.textColorBlack,
                                    'text-width-limiter': paragraph.textWidthLimiter
                                    }"
                                 v-if="paragraph && paragraph.text && !config.certificateEdit" v-html="paragraph.text"></p>
                            </template>
                        </div>

                        <div v-if="config.easterModal">
                            <img class="qr-code-easter" :src="config.QRcodeURL" alt="" />
                            <p class="qr-code-phara" v-html="config.resources.description"></p>
                        </div>

                        <div v-if="config.qrModal">
                            <img class="js-qrCode qr-code" :src="config.QRcodeURL" alt="" />
                            <p class="js-qr-description qr-code-phara" v-html="config.description"></p>
                        </div>

                        
                        <div id="talisman-certificate-content" class="talisman-certificate-content" v-if="config.certificateEdit">
                            <p v-html="config.resources.description"></p>
                            <label for="personalizedName">{{ config.resources.name }}</label>
                            <span class="error" v-if="msg.personalizedName">{{msg.personalizedName}}</span>
                            <input id="personalizedName" v-model="personalizedName" type="text" maxlength="12" :placeholder="config.resources.placeholder" />
                            <p class="disclaimer" v-html="config.resources.note"></p>
                        </div>

                        <div id="bonus-product-list" class="bonus-product-list-slider drag-list" v-if="config.productTiles"
                            :data-line-item-detail="config.configuration && config.configuration.lidata">
                            <div data-list-config='{"itemsToShow":"1.5","hideArrows":true, "hideBar":true, "isMobileOnly": true}'
                                :class="['drag-list-scroll', {'js-drag-list js-drag-list-center': enableDraglist}]">
                                <template v-for="productTile in config.productTiles">
                                    <div :id="productTile.id" :data-producttype="productTile.productType"
                                        :class="['bonus-product-list-slider-item', {'js-drag-list-item': enableDraglist}]">
                                        <label :id="productTile.popupProductID">
                                            <input class="gwp-radio--hidden js-bonus-product-selection" type="radio" name="popup-bonus-product-select"
                                                :data-pid="productTile.productID"
                                                :data-productuuid="productTile.productUUID"
                                                :data-bonusdiscountlineitemuuid="productTile.bonusDiscountLineItemUUID"
                                                :data-bonusproductid="productTile.bonusProductID"
                                                :checked="productTile.bonusProductID == productTile.productID"
                                            />
                                            <span class="product-name" v-if="productTile && productTile.productName" v-html="productTile.productName"></span>

                                            <div class="product-image" v-if="productTile && productTile.productImageUrl">
                                                <img :data-src="productTile.productImageUrl" :alt="productTile.productImageAlt" :title="productTile.productImageTitle"
                                                    :class="productTile.productImageClass" :src="productTile.productImagePlaceholder"/>
                                            </div>

                                            <div class="select-box-wrapper">
                                                <span class="gwp-select-box"
                                                    :aria-labelledby="productTile.popupProductID"
                                                    tabindex="0"
                                                    role="radio"
                                                    :aria-checked="productTile.bonusProductID == productTile.productID"
                                                ></span>
                                            </div>
                                        </label>
                                    </div>
                                </template>
                            </div>
                        </div>

                        <div class="cta-holder"
                            :class="{
                                'cta-holder-row': config.ctaHolderRow,
                                'hide-on-mobile-and-tablet': config.ctaHolder.hideOnMobileAndTablet
                            }">
                            <template v-for="button in config.buttons">
                                <div class="row row-custom-width" :class="config.row && config.row.rowWidth" v-if="button && button.label">
                                    <div class="flag-wrapper" v-if="button && button.prependedBlock" v-html="button.prependedBlock"></div>
                                    <button
                                        v-html="button.label"
                                        :class="button.type"
                                        type="button"
                                        @click="button.shouldCloseModal
                                            ? (button.eventName ? !onElementClick(button.eventName, button.data) && closeModal() : closeModal())
                                            : onElementClick(button.eventName, button.data)"
                                        :disabled='isDisabled && button.shouldBeValid'
                                    ></button>
                                </div>
                            </template>
                        </div>

                        <p class="verification-message" v-if="config.configuration && config.configuration.verificationMessage" v-html="config.configuration.verificationMessage"></p>
                        <input type="hidden" class="js-gwp-tier-step" v-if="config.configuration && config.configuration.fixedTierStep" :value="config.configuration.fixedTierStep" />
                    </div>
                </div>
            </div>
        </transition>

        <transition name="generic-modal-overlay-transition">
            <div class="generic-modal-overlay"
                  v-show="isModalVisible"
                  @click="() => handleCloseModal(config)"
                >
            </div>
        </transition>
    </div>
</template>

<script src='./modal.js' />
